import FinishStep from './FinishStep';
import UploadStep from './UploadStep';
import ValidationStep from './ValidationStep';

export default {
  title: 'Volgers',
  steps: {
    upload: 'Uploaden',
    validate: 'Bevestigen',
    finish: 'Klaar',
  },
  labels: {
    import: 'Importeren',
  },

  FinishStep,
  UploadStep,
  ValidationStep,
};
